import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function News() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/news").then((r) => setPosts(r.data.posts || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="news-page">
      <section className="section">
        <div className="container-editorial">
          <div className="eyebrow">News & blog</div>
          <h1 className="mt-4 font-serif text-5xl leading-[1.05] text-ink md:text-6xl">
            Field notes from the <em className="not-italic text-clay">restoration</em>.
          </h1>

          <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((p, i) => (
              <article key={p.id} data-testid={`post-${p.id}`} className={`overflow-hidden rounded-3xl border border-clay/15 bg-white ${i === 0 ? "md:col-span-2 lg:col-span-2 lg:row-span-2" : ""}`}>
                <div className={`overflow-hidden ${i === 0 ? "aspect-[16/9]" : "aspect-[16/10]"}`}>
                  <img src={p.image} alt={p.title} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-3 text-xs uppercase tracking-[0.22em] text-clay">
                    <span className="font-bold">{p.tag}</span>
                    <span className="h-1 w-1 rounded-full bg-clay/50" />
                    <span className="text-ink-muted">{new Date(p.date).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}</span>
                  </div>
                  <h3 className={`mt-3 font-serif text-ink ${i === 0 ? "text-3xl md:text-4xl" : "text-2xl"}`}>{p.title}</h3>
                  <p className="mt-3 text-sm text-ink-muted">{p.excerpt}</p>
                  <div className="mt-6 flex items-center justify-between text-sm">
                    <span className="text-ink-muted">By {p.author}</span>
                    <a href="#" className="inline-flex items-center gap-2 font-semibold text-clay hover:text-clay-600">
                      Read more <ArrowRight className="h-4 w-4" />
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
